
<template>
  <div>Hello world</div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>
